// extracted by mini-css-extract-plugin
module.exports = {"customCheckboxFilter":"filter-group_customCheckboxFilter__vfW4f"};